// Lib
import { createApi } from "@reduxjs/toolkit/query/react";
// Types
import { UrlQueryParams } from "types/common";
import { GetReportsResponseDto, GetReportsInProgress } from "types/reports";
// Constants
import { endpoints } from "consts";
// Helpers
import { reportsUrlBuilder } from "./urlBuilder/reports";
// Utils
import { coreQuery } from "utils/baseQuery";

export const reportsAPI = createApi({
  reducerPath: "reportsAPI",
  baseQuery: coreQuery(),
  tagTypes: ["reports", "reports-in-progress"],

  endpoints: build => ({
    getReports: build.query<GetReportsResponseDto, { query: UrlQueryParams }>({
      query: ({ query }) => ({
        url: reportsUrlBuilder.getReports({ query }),
        method: "GET",
      }),
      providesTags: ["reports"],
    }),
    getReportsInProgress: build.query<GetReportsInProgress, void>({
      query: () => ({
        url: `${endpoints.reports}/in-progress`,
        method: "GET",
      }),
      providesTags: ["reports-in-progress"],
    }),
    createReport: build.mutation<void, any>({
      query: data => ({
        url: endpoints.reports,
        method: "POST",
        data,
      }),
      invalidatesTags: ["reports", "reports-in-progress"],
    }),
    deleteReport: build.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `${endpoints.reports}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["reports"],
    }),
    downloadReport: build.query<Blob, { id: string }>({
      query: ({ id }) => ({
        url: `${endpoints.reports}/${id}/download`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetReportsQuery,
  useCreateReportMutation,
  useDeleteReportMutation,
  useLazyDownloadReportQuery,
  useGetReportsInProgressQuery,
} = reportsAPI;
